<!--
 * @Author: YuanYuan
 * @Date: 2024-02-04 19:44:22
 * @LastEditTime: 2026-01-30 14:07:29
 * @description: 左侧菜单
-->
<template>
  <nav class="left-menu">
    <div v-if="showProductSwitch" class="left-menu_header">
      <span class="left-menu_title" v-if="showMenuTitle">{{ curMenuTitle }}</span>
      <template v-else>
        <span class="left-menu_title" :title="curProductName()">{{ curProductName() }}</span>
        <el-dropdown placement="right" @command="commandHandler">
          <el-button type="text" icon="ws-icon-replace relative-top-2"></el-button>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item
                v-for="item in $const['Common/GoodsCodeOptions']"
                :key="item.value"
                :command="item.value">
                {{ findProductName(item.productType) }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </template>
    </div>
    <div
      class="left-menu_content"
      :style="{
        height: showProductSwitch ? 'calc(100% - 90px)' : 'calc(100% - 40px)'
      }">
      <slot></slot>
      <el-menu
        v-if="menuList?.length"
        :key="menuTitle"
        :collapse-transition="false"
        :default-active="activeLeftMenu"
        class="left-menu_el_menu">
        <template v-for="(item, itemIdx) in menuList">
          <el-submenu
            v-if="item?.children?.length"
            :key="itemIdx"
            :index="`${itemIdx}_${item.code}`">
            <template slot="title">{{item[sthFromLang('nameCn', 'nameEn')]}}</template>
            <el-menu-item
              v-for="(subItem, subIdx) in item.children"
              :key="`${itemIdx}_${subIdx}`"
              :index="toFrontUrl(subItem.url)"
              :title="subItem[sthFromLang('nameCn', 'nameEn')]"
              @click="toMenuUrl(subItem)">
              {{subItem[sthFromLang('nameCn', 'nameEn')]}}
            </el-menu-item>
          </el-submenu>
          <template v-else>
            <el-menu-item
              :key="itemIdx"
              :index="toFrontUrl(item.url)"
              :title="item[sthFromLang('nameCn', 'nameEn')]"
              @click="toMenuUrl(item)">
              {{item[sthFromLang('nameCn', 'nameEn')]}}
            </el-menu-item>
          </template>
        </template>
      </el-menu>
    </div>
  </nav>
</template>

<script setup>
import { computed, getCurrentInstance, watch, ref } from 'vue'
import { toMenuUrl, sthFromLang, filterMenus, switchCurProduct, findProductName, getCurrentGoodsCode } from '@/utils/base'
import { find } from 'lodash-es'

const props = defineProps({
  showProductSwitch: {
    type: Boolean,
    default: true
  },
  staticMenuData: {
    type: Array,
    default: () => []
  }
})
  
const $vm = getCurrentInstance().proxy

const showMenuTitle = computed(() => {
  const curLeftMenuCode = $vm.$route.meta?.leftMenuCode
  return curLeftMenuCode && (curLeftMenuCode === 'Bills' || curLeftMenuCode === 'User')
})
const curMenuData = computed(() => filterMenus($vm.$route.meta.leftMenuCode))
const menuTitle = computed(() => curMenuData.value?.[sthFromLang('nameCn', 'nameEn')])
const menuList = computed(() => {
  if (props.staticMenuData?.length) {
    return props.staticMenuData
  }
  return curMenuData.value?.children || []
})
const curMenuTitle = computed(() => curMenuData.value[sthFromLang('nameCn', 'nameEn')])
const activeLeftMenu = ref('')

const curProductName = () => {
  const curGoodsCode = getCurrentGoodsCode()
  const curProductType = find($vm.$const['Common/GoodsCodeOptions'], { value: curGoodsCode })?.productType
  return findProductName(curProductType)
}

const toFrontUrl = url => {
  return url?.split('#')[1] || url
}

const commandHandler = val => {
  switchCurProduct(val)
}

watch(() => $vm.$route, newVal => {
  activeLeftMenu.value = newVal.meta.leftActiveIndex || newVal.path
}, { immediate: true, deep: true })
</script>

<style lang="scss" scoped>
$menuItemHeight: 44px;
.left-menu{
  height: 100%;
  &_header{
    height: 50px;
    border-bottom: 1px solid #d9d9d9;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 15px;
    font-weight: bold;
    color: rgba(0,0,0,0.85);
  }
  &_title{
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &_content{
    border-bottom: 1px solid $ws-gray-4;
    overflow-y: auto;
  }
  ::v-deep &_el_menu{
    border-right: none;
    background-color: #fff;
    .el-submenu{
      .el-menu-item{
        padding: 0 18px 0 45px;
      }
      .el-submenu__title{
        height: $menuItemHeight;
        line-height: $menuItemHeight;
      }
      .el-menu-item.is-active{
        &::before{
          left: 30px;
        }
      }
    }
    .el-menu-item{
      height: $menuItemHeight;
      line-height: $menuItemHeight;
      overflow: hidden;
      text-overflow: ellipsis;
      &.is-active{
        background: linear-gradient( 90deg, #9D59EF 0%, #6940CC 100%);
        box-shadow: 5px 0px 15px 0px rgba(73,72,117,0.3);
        color: rgba(255,255,255,0.85);
        position: relative;
        &::before{
          content: '';
          width: 5px;
          height: 5px;
          background-color: #fff;
          box-shadow: 5px 0px 15px 0px rgba(73,72,117,0.3);
          border-radius: 5px;
          position: absolute;
          left: 10px;
          top: 20px;
        }
      }
    }
  }
}
</style>
